import { render, staticRenderFns } from "./bindTable.vue?vue&type=template&id=18de90ae&scoped=true&"
import script from "./bindTable.vue?vue&type=script&lang=js&"
export * from "./bindTable.vue?vue&type=script&lang=js&"
import style0 from "./bindTable.vue?vue&type=style&index=0&id=18de90ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de90ae",
  null
  
)

export default component.exports